import { OrganizationRole } from '@/enums/roles';
import CreateOrganization from '@/views/organizations/CreateOrganization.vue';
import EditOrganization from '@/views/organizations/EditOrganization.vue';
import OrganizationInformation from '@/views/organizations/OrganizationInformation.vue';
import PickOrganization from '@/views/organizations/PickOrganization.vue';
import UnderlyingOrganizations from '@/views/organizations/UnderlyingOrganizations.vue';
import type { RouteRecordRaw } from 'vue-router';

const routes: readonly RouteRecordRaw[] = [
    {
        path: '/bedrijf/:organizationId/vestigingen',
        name: 'organization-underlying',
        component: UnderlyingOrganizations,
        meta: {
            pageTitle: 'Vestigingen',
            roles: [OrganizationRole.Employee]
        }
    },
    {
        path: '/bedrijf/:organizationId/informatie',
        name: 'organization-profile',
        component: OrganizationInformation,
        meta: {
            pageTitle: 'Informatie',
            roles: [OrganizationRole.Employee]
        }
    },
    {
        path: '/bedrijf-maken/:organizationId?',
        name: 'organization-create',
        component: CreateOrganization,
        meta: {
            pageTitle: 'Bedrijf maken',
            roles: [OrganizationRole.Admin]
        }
    },
    {
        path: '/bedrijf-bewerken/:organizationId',
        name: 'organization-edit',
        component: EditOrganization,
        meta: {
            pageTitle: 'Bedrijf bewerken',
            roles: [OrganizationRole.Admin]
        }
    },
    {
        path: '/bedrijf-selecteren',
        name: 'organization-switch',
        component: PickOrganization,
        meta: {
            pageTitle: 'Bedrijf wisselen',
            roles: [OrganizationRole.Employee]
        }
    }
];

export default routes;
